var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-update" }, [
    _c("p", [_vm._v("New version is available")]),
    _vm._v(" "),
    _c("p", [_vm._v("Please refresh the page")]),
    _vm._v(" "),
    _c("div", { staticClass: "controls" }, [
      _c("button", { staticClass: "cta-button", on: { click: _vm.refresh } }, [
        _vm._v("\n      Update\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }